import { apiClient } from "../config/api.config";
import { AppNotification } from "../types/notification.definition";

export function getNotifications() {
  return apiClient.request<AppNotification[]>({
    method: "get",
    url: "/notifications",
  });
}

export function markNotificationAsRead(id: number) {
  return apiClient.request<AppNotification>({
    method: "put",
    url: `/notifications/${id}/read`,
  });
}

export function markAllNotificationsAsRead() {
  return apiClient.request<void>({
    method: "put",
    url: "/notifications/read-all",
  });
}

export function deleteNotification(id: number) {
  return apiClient.request<void>({
    method: "delete",
    url: `/notifications/${id}`,
  });
}
